<template>
  <div class="giveaway">
    <div class="image" v-if="giveaway.image">
      <img :src="`https://${fqdn}.streamify.io/images/w/48/${giveaway.image}`" />
    </div>
    <div class="info elippsiss">
      <h2>{{ giveaway.title }}</h2>
      <p class="elippsiss">{{ giveaway.description }}</p>
    </div>
    <i class="icon-chevron-right" />
  </div>
</template>

<script>
export default {
  props: {
    giveaway: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.giveaway {
  align-items: center;
  display: flex;
  min-height: 72px;
  position: relative;
  padding: 0 40px 0 12px;

  .image {
    margin-right: 12px;
    min-width: 48px;
  }

  .info {
    flex: 1;

    h2 {
      font-size: 16px;
      font-weight: 500;
    }

    p {
      font-size: 12px;
      color: #727479;
      max-width: 50%;
    }
  }

  i {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    line-height: 0;
    font-size: 24px;
    color: var(--color-cta-blue);
  }

  &:hover {
    background-color: #DBE9FF;
    cursor: pointer;
  }

  &:first-child {
    border-radius: 10px 10px 0 0;
  }

  &:only-child {
    border-radius: 10px;
  }

  &:last-child {
    border-radius: 0 0 10px 10px
  }

  &:not(:last-child) {
    border-bottom: 1px solid #F4F5F9;
  }
}
</style>
